const deliveryTime = document.querySelector('.delivery_time');

function deliveryTimeToggle(event) {
  if (event.detail.variant.available == false) {
    deliveryTime.style.display = 'none';
  } else {
    deliveryTime.style.display = 'block';
  }
}

if (deliveryTime) document.addEventListener("variant:change", (event) => deliveryTimeToggle(event));

// toggle best before date badge for products

const bbdBadge = document.querySelectorAll('.variant-picker__option-info .bbd-badge');

function toggleBBDBadge(e) {
  // console.log(e.detail.variant.id)
  bbdBadge.forEach(badge => {
    e.detail.variant.id == badge.getAttribute('data-id') ? badge.removeAttribute('hidden') : badge.setAttribute('hidden', '');
  })
}

if (bbdBadge) document.addEventListener("variant:change", (e) => toggleBBDBadge(e));

const mixAndMatchLink = document.getElementById('mix-and-match-pdp-link');

function toggleMixAndMatchLink(event) {
  if (!mixAndMatchLink) return;
  mixAndMatchLink.hidden = !event.detail?.variant?.available;
}

if (mixAndMatchLink) document.addEventListener('variant:change', toggleMixAndMatchLink);

// cookie banner
let stopObserver = false;
function updateAnchorHrefs(banner) {
  const anchors = banner.querySelectorAll('a');
  const lang = document.querySelector('html').getAttribute('lang');
  anchors.forEach(anchor => {
    const currentHref = anchor.getAttribute('href');
    if (lang == 'en' && currentHref && !currentHref.startsWith('/en') && !currentHref.includes('http')) {
      anchor.setAttribute('href', '/en' + currentHref);
      stopObserver = true;
    }else if (lang !== 'en'){
      stopObserver = true;
    }
  });
}

function observeForBanner() {
  const documentObserver = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.classList && node.classList.contains('cc-overlay-wrapper')) {
          updateAnchorHrefs(node);
          if(stopObserver) observer.disconnect();
        }
      });
    });
  });

  documentObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

observeForBanner();

class PageAtc extends HTMLElement {
  connectedCallback() {
    this._form = this.querySelector('form');
    this._button = this.querySelector('button[type="submit"]');
    this._headline = this.querySelector('.page-atc__headline-text');
    this._icon = this.querySelector('.page-atc__headline .icon');
    this._onVariantChanged = this._onVariantChanged.bind(this);

    this._form?.addEventListener('variant:change', this._onVariantChanged);

    if (!this.hasAttribute('sticky')) return;
    if (window.Shopify?.designMode) return;

    this._footer = document.querySelector('.footer');
    if (!this._footer) return;

    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('is-hidden', entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -80px 0px' }
    );
    this._observer.observe(this._footer);
  }

  disconnectedCallback() {
    this._form?.removeEventListener('variant:change', this._onVariantChanged);
    this._observer?.disconnect();
  }

  _onVariantChanged(event) {
    const variant = event.detail?.variant;
    const available = Boolean(variant?.available);
    const unavailableText = this.getAttribute('data-unavailable-text');
    const headline = this.getAttribute('data-headline');

    this.classList.toggle('page-atc--unavailable', !available);
    if (this._button) this._button.disabled = !available;
    if (this._headline) {
      this._headline.textContent = available ? headline : unavailableText;
    }
    if (this._icon) this._icon.toggleAttribute('hidden', !available);
  }
}

if (!customElements.get('page-atc')) {
  customElements.define('page-atc', PageAtc);
}

